<template>
  <div
    class="modal fade"
    id="DdfixChangeModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Change from Fixed DD</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('cancel')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          Changing the payment method will cancel the current fixed payment instruction/s.<br>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('cancel')">Cancel</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('ok')">Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'DdfixChangeModal',
};
</script>
